import { EventBus } from 'core-components/classes/events/Bus'

export enum AppEvents {
  onRoleRequest = 'onRoleRequest',
  onRoleRequestAnswer = 'onRegistrationRequestAnswer',
}

export const appEventBusInfo = {
  filterEvents: [AppEvents.onRoleRequest, AppEvents.onRoleRequestAnswer],
  busName: 'AppEventsBusService',
}

export const appEventBus = new EventBus(appEventBusInfo.filterEvents, appEventBusInfo.busName)

export enum AppHTTPRequest {
  response401 = 'response401',
}

export const appHTTPRequestBus = new EventBus([AppHTTPRequest.response401], 'httpRequestBus')
